import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import App from './views/App';
import store from './store';
import './moment.setup';
import './themes/global.scss';
import ScrollToTop from './components/ScrollToTop';
/**
 * The application main entrypoint.
 */
var Index = function () { return (React.createElement(Provider, { store: store },
    React.createElement(ErrorBoundary, null,
        React.createElement(BrowserRouter, null,
            React.createElement(ScrollToTop, null),
            React.createElement(App, null))))); };
ReactDOM.render(React.createElement(Index, null), document.getElementById('app-root'));
